import { render, staticRenderFns } from "./DetaiInfoPage.vue?vue&type=template&id=79e7fa3f&scoped=true&"
import script from "./DetaiInfoPage.vue?vue&type=script&lang=js&"
export * from "./DetaiInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./DetaiInfoPage.vue?vue&type=style&index=0&id=79e7fa3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7fa3f",
  null
  
)

export default component.exports